export default "__VITE_PUBLIC_ASSET__3983ca9c__"